import type { IconData } from '@stacksjs/iconify-core'

export const closedCaptioning: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 64H40a24.03 24.03 0 0 0-24 24v336a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V88a24.03 24.03 0 0 0-24-24m-8 352H48V96h416Z\"/><path fill=\"currentColor\" d=\"M184 344a87.1 87.1 0 0 0 54.484-18.891l-19.825-25.119A55.4 55.4 0 0 1 184 312a56 56 0 0 1 0-112a55.4 55.4 0 0 1 34.659 12.01l19.825-25.119A87.1 87.1 0 0 0 184 168a88 88 0 0 0 0 176m163.429 0a87.1 87.1 0 0 0 54.484-18.891l-19.825-25.119A55.4 55.4 0 0 1 347.429 312a56 56 0 0 1 0-112a55.4 55.4 0 0 1 34.659 12.01l19.825-25.119A87.1 87.1 0 0 0 347.429 168a88 88 0 0 0 0 176\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default closedCaptioning
